import { createFileRoute, redirect, useRouterState } from "@tanstack/react-router";
import type { JSX } from "react";
import ProjectDetailPage, {
	PROJECT_DETAIL_TAB_TO,
	type ProjectTabKey,
	pathToProjectDetailTab,
} from "@/components/settings/projects/project-detail-page";

const LEGACY_SEARCH_TABS: readonly ProjectTabKey[] = ["tasks", "hours", "report"];

const ProjectDetailLayout = (): JSX.Element => {
	const { id } = Route.useParams();
	const pathname = useRouterState({ select: (state) => state.location.pathname });
	const tab = pathToProjectDetailTab(pathname, id) ?? "details";
	return <ProjectDetailPage projectId={id} tab={tab} />;
};

export const Route = createFileRoute("/_app/settings/projects/$id")({
	beforeLoad: ({ params, search }) => {
		const tab = typeof search === "object" && search && "tab" in search ? search.tab : undefined;
		if (typeof tab === "string" && (LEGACY_SEARCH_TABS as readonly string[]).includes(tab)) {
			throw redirect({
				params: { id: params.id },
				replace: true,
				to: PROJECT_DETAIL_TAB_TO[tab as Exclude<ProjectTabKey, "details">],
			});
		}
	},
	component: ProjectDetailLayout,
});
